// src/elements/Brand/generated/printdeal-brands.types.ts
var NAME_MAP = {
  "drukwerkdeal": "drukwerkdeal",
  "printdeal-be": "printdeal-be"
};
export { NAME_MAP };